export default "__VITE_ASSET__e6d483fe__"